/**
 * 會員中心的表單小工具（0914-1 第 3 步之二）：送出前確認、全選。只掛在需要它的頁面
 * （「我的訊息」列表、發訊息、群組發送、群組名單管理…）。
 *
 * 舊站 `Member/MessageList.aspx`：
 *   - 每則的刪除 `f_delete(id)` → `confirm('確定刪除!?')`
 *   - 「勾選刪除」`OnClientClick="return confirm('確定將勾選項目刪除!?')"`
 *   - 「全選」連結與旁邊的 checkbox：把每一則的 `cbSelect` 設成那個 checkbox 的狀態
 *
 * ────────────────────────────────────────────────────────────────
 * 沒有 JS 時
 * ────────────────────────────────────────────────────────────────
 * 不問就送出（伺服器端的規則照常：一則都沒勾 → 「請勾選需刪除項目!!」）；全選不作用，逐則勾選照樣可用。
 * ⚠️ 確認框只是「按錯的保險」，**不是**防護 —— 防護是 POST ＋ antiforgery（伺服器端）。
 */

/** 按鈕（或表單）上的確認文字。 */
const CONFIRM_ATTR = 'data-p9-confirm';

/** 「全選」checkbox：值是要一起勾選的那些框的 `form` 屬性（表單 id）。 */
const SELECT_ALL_ATTR = 'data-p9-select-all';

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  // ⚠️ 先看按下的那顆按鈕（「勾選刪除」用 form 屬性掛在表單外），再看表單本身。
  const submitter = (event as SubmitEvent).submitter;
  const message = submitter?.getAttribute(CONFIRM_ATTR) ?? form.getAttribute(CONFIRM_ATTR);

  if (message && !window.confirm(message)) {
    event.preventDefault();
  }
});

/**
 * 送出後把按鈕停用，避免連按兩次寄兩封（舊站 SendMessage.aspx `Submit()`：`setTimeout(… attr('disabled'), 100)`）。
 * ⚠️ 等瀏覽器真的開始送出（submit 事件沒被取消）才停用；停用太早，按鈕的 name/value 會送不出去。
 */
const ONCE_ATTR = 'data-p9-once';

/** 動了這個欄位就把指定的 radio 勾起來（舊站：選好友下拉 → 勾「好友」、在帳號欄打字 → 勾「帳號」）。 */
const CHECK_ATTR = 'data-p9-check';

document.addEventListener('submit', (event) => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement) || !form.hasAttribute(ONCE_ATTR)) {
    return;
  }

  window.setTimeout(() => {
    if (!event.defaultPrevented) {
      for (const button of form.querySelectorAll<HTMLButtonElement>('button[type="submit"]')) {
        button.disabled = true;
      }
    }
  }, 0);
});

for (const field of document.querySelectorAll<HTMLElement>(`[${CHECK_ATTR}]`)) {
  const radio = document.getElementById(field.getAttribute(CHECK_ATTR) ?? '');

  if (radio instanceof HTMLInputElement) {
    const check = () => { radio.checked = true; };
    field.addEventListener('change', check);
    field.addEventListener('input', check);
  }
}

for (const master of document.querySelectorAll<HTMLInputElement>(`input[type="checkbox"][${SELECT_ALL_ATTR}]`)) {
  const formId = master.getAttribute(SELECT_ALL_ATTR);

  if (!formId) {
    continue;
  }

  master.addEventListener('change', () => {
    for (const box of document.querySelectorAll<HTMLInputElement>('input[type="checkbox"][name="ids"]')) {
      if (box.getAttribute('form') === formId) {
        box.checked = master.checked;
      }
    }
  });
}

/**
 * 分區的「全選」（群組發送：好友、家族成員、每個群組各一區，同在一張表單裡）：
 * 值是區名，帶動同一區 `data-p9-scope` 的勾選框（舊站 `$('input.Friend').attr('checked', …)`）。
 */
const SELECT_SCOPE_ATTR = 'data-p9-select-scope';

const SCOPE_ATTR = 'data-p9-scope';

for (const master of document.querySelectorAll<HTMLInputElement>(`input[type="checkbox"][${SELECT_SCOPE_ATTR}]`)) {
  const scope = master.getAttribute(SELECT_SCOPE_ATTR);

  if (!scope) {
    continue;
  }

  master.addEventListener('change', () => {
    for (const box of document.querySelectorAll<HTMLInputElement>(`input[type="checkbox"][${SCOPE_ATTR}]`)) {
      if (box.getAttribute(SCOPE_ATTR) === scope) {
        box.checked = master.checked;
      }
    }
  });
}

/** 下拉選了就送出（舊站 `AutoPostBack="True"`）；沒有 JS 時旁邊的按鈕照樣可用。 */
const AUTOSUBMIT_ATTR = 'data-p9-autosubmit';

for (const field of document.querySelectorAll<HTMLSelectElement>(`select[${AUTOSUBMIT_ATTR}]`)) {
  field.addEventListener('change', () => {
    field.form?.requestSubmit();
  });
}
